// 시트 이름
export const SUMMARY_SHEET_NAME = "요약";
export const DB_SHEET_NAME = "모든 제품";
// 데이터 시작 행 번호 (헤더 다음 행)
export const DATA_START_ROW = 2;
// 뷰어 시트 정보
export const LAST_COLUMN_LETTER = "O"; // 뷰어 시트의 마지막 열 (사진까지)
export const DEFAULT_BORDER = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
};
